"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _client = require("@apollo/client");
var _env = _interopRequireDefault(require("./env"));
var _init = require("./apollo/init");
var _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var send = function send(eventName, eventPayload, options) {
  if (!window.Tracker || !_env["default"].isProduction()) {
    console.log('Tracker:', eventName, eventPayload, options); // eslint-disable-line no-console
    return;
  }
  window.Tracker.track(eventName, eventPayload, options)["catch"](console.error); // eslint-disable-line no-console
};
var Tracker = /*#__PURE__*/function () {
  function Tracker(chat, accountId, listId, version, renderProps) {
    _classCallCheck(this, Tracker);
    var objectName = listId ? 'item_page' : 'chat';
    Object.assign(this, {
      chat: chat,
      accountId: accountId,
      objectName: objectName,
      renderProps: renderProps,
      version: version
    });
  }
  return _createClass(Tracker, [{
    key: "sendEvent",
    value: function sendEvent(listId, eventName) {
      var client = (0, _init.initApollo)();
      client.query({
        query: (0, _client.gql)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            query getAdFromId($listId: String!) {\n              enhancedAd(listId: $listId) {\n                subject\n                legacyAdId\n                listId\n                sellerId\n                sellerNickname\n                priceValue\n                searchCategoryLevelZero\n                parentCategory\n                parentCategoryName\n                categoryName\n                category\n                professionalAd\n                olxDeliveryEnabled\n                olxPayEnabled\n                location {\n                    uf\n                    ddd\n                    region\n                    municipality\n                    neighbourhood\n                }\n                properties {\n                    label\n                    name\n                    value\n                }\n              }\n            }\n          "]))),
        variables: {
          listId: listId
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'ignore'
      }).then(function (_ref) {
        var data = _ref.data,
          errors = _ref.errors;
        if (errors || !data || !(data !== null && data !== void 0 && data.enhancedAd)) {
          return;
        }
        send(eventName, {
          adId: data.enhancedAd.legacyAdId,
          listId: data.enhancedAd.listId,
          subject: data.enhancedAd.subject,
          priceValue: data.enhancedAd.priceValue,
          searchCategoryLevelZero: data.enhancedAd.searchCategoryLevelZero,
          parentCategory: data.enhancedAd.parentCategory,
          parentCategoryName: data.enhancedAd.parentCategoryName,
          categoryName: data.enhancedAd.categoryName,
          category: data.enhancedAd.category,
          user: {
            publicAccountId: data.enhancedAd.sellerId,
            name: data.enhancedAd.sellerNickname
          },
          professionalAd: data.enhancedAd.professionalAd,
          location: {
            uf: data.enhancedAd.location.uf,
            ddd: data.enhancedAd.location.ddd,
            region: data.enhancedAd.location.region,
            municipality: data.enhancedAd.location.municipality,
            neighbourhood: data.enhancedAd.location.neighbourhood
          },
          olxPay: {
            enabled: data.enhancedAd.olxPayEnabled
          },
          olxDelivery: {
            enabled: data.enhancedAd.olxDeliveryEnabled
          },
          properties: data.enhancedAd.properties
        });
      })["catch"](function () {});
    }
  }, {
    key: "replyChat",
    value: function replyChat(listId) {
      this.sendEvent(listId, 'reply_chat');
    }
  }, {
    key: "replyShowPhone",
    value: function replyShowPhone(listId) {
      this.sendEvent(listId, 'reply_show_phone');
    }
  }]);
}();
var _default = exports["default"] = Tracker;